import { useChunkTranslation } from "../hooks";

var SuspenseChunkTranslation = function SuspenseChunkTranslation(_ref) {
  var children = _ref.children,
      chunkFile = _ref.chunkFile,
      fallback = _ref.fallback,
      options = _ref.options;
  var done = useChunkTranslation(chunkFile, options());
  return /*#__PURE__*/React.createElement(React.Fragment, null, done ? children : fallback);
};

export { SuspenseChunkTranslation };